var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("考点信息")]),_c('Table',{staticClass:"table",attrs:{"border":"","columns":_vm.columns2,"data":_vm.CenterInfos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }